/**
 * AOS (npm) — same as former wp_add_inline_script( 'aos-js', 'AOS.init();' ).
 * Library attaches to module.exports when bundled; normalise and expose window.AOS.
 */
import * as aosModule from 'aos';

var AOS = aosModule.default || aosModule;

function run() {
	if (AOS && typeof AOS.init === 'function') {
		AOS.init();
	}
}

if (typeof window !== 'undefined') {
	window.AOS = AOS;
}

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
}
